import { HandlebarsRender } from "./handlebars";
import { getFormJSON, SetLoc, SetWar, formatAmount, isoCurrency, GetCurrency } from "./utils";
import { validateReserve } from "./swal";
import { GetLoc, GetWar, NewCartCode } from "./utils";
import { v4 as uuidv4 } from 'uuid';
export class CartSettings {
    constructor(indicatorDisplayID, indicatorDisplayNonEmptyClass, qtyDisplayClass, totalDisplayClass, subtotalDisplayClass, discountDisplayClass, taxesDisplayClass, headerdetailsDisplayClass, footerdetailsDisplayClass, addProductSuccessCallback, addProductErrorCallback, validatorAPI) {
        this.indicatorDisplayID = indicatorDisplayID;
        this.indicatorDisplayNonEmptyClass = indicatorDisplayNonEmptyClass;
        this.qtyDisplayClass = qtyDisplayClass;
        this.totalDisplayClass = totalDisplayClass;
        this.subtotalDisplayClass = subtotalDisplayClass;
        this.discountDisplayClass = discountDisplayClass;
        this.taxesDisplayClass = taxesDisplayClass;
        this.headerdetailsDisplayClass = headerdetailsDisplayClass;
        this.footerdetailsDisplayClass = footerdetailsDisplayClass;
        this.addProductErrorCallback = addProductErrorCallback;
        this.addProductSuccessCallback = addProductSuccessCallback;
        this.validatorAPI = validatorAPI;
    }
}
export class Cart {
    is_valid() {
        return this.validation.valid;
    }
    startCart(containerSelector, templateSelector, emptyTemplateSelector, containerFormFilterSelector) {
        this.containerSelector = containerSelector;
        this.containerFormFilterSelector = containerFormFilterSelector;
        this.templateSelector = templateSelector;
        this.emptyTemplateSelector = emptyTemplateSelector;
        this.formFilter = this.getFormFilter();
        this.QueryCart();
    }
    getFormFilter() {
        if (!this.formFilter) {
            this.formFilter = document.querySelector(this.containerFormFilterSelector);
            if (this.formFilter) {
                this.formFilter.addEventListener('submit', this.onFormFilterSubmit);
            }
        }
        return this.formFilter;
    }
    getFormData() {
        this.formFilter = document.querySelector(this.containerFormFilterSelector);
        if (this.formFilter) {
            return getFormJSON(this.formFilter);
        }
        return this.formData;
    }
    is_empty() {
        return this.repo.length + this.bundles.length == 0;
    }
    addPromocode(code) {
        code = code.trim();
        if (!code) {
            return;
        }
        let current = this.promocodes.filter(promo => {
            return promo['code'].toString() == code;
        });
        if (current.length > 0) {
            return 2;
        }
        this.promocodes.push({ 'code': code });
        this.save();
        this.QueryCart();
    }
    removePromocode(id) {
        this.promocodes = this.promocodes.filter(promo => {
            if (promo && promo['id']) {
                return promo['id'].toString() != id;
            }
            return false;
        });
        this.save();
        this.QueryCart();
    }
    constructor(identifier, settings) {
        this.repo = [];
        this.data = {};
        this.final_lines = [];
        this.productQty = 0;
        this.promocodes = [];
        this.bundles = [];
        this.exchanges = {};
        this.currency = '';
        this.total = 0.0;
        this.subtotal = 0.0;
        this.discount_subtotal = 0.0;
        this.discount = 0.0;
        this.discounts = [];
        this.shipping_cost = 0.0;
        this.shipping_cost_taxes = 0.0;
        this.taxes = {};
        this.plugins = {};
        this.extras = {};
        this.validation = {};
        this.formData = null;
        this.formFilter = null;
        this.initial = true;
        this.identifier = identifier;
        this.settings = settings;
    }
    getCurrency() {
        return this.currency;
    }
    setCurrency(value) {
        this.currency = value;
        this.save();
        console.log('raise', 'CartChangeCurrency');
        document.dispatchEvent(new CustomEvent('CartChangeCurrency', {
            'detail': {
                'cart': this,
            }
        }));
    }
    setDefaultCurrency(value) {
        if (!this.currency) {
            this.setCurrency(value);
        }
    }
    setText(object, text) {
        if (object) {
            object.textContent = text;
        }
    }
    formatAmount(value, dp = null) {
        return formatAmount(value, dp);
    }
    stringify() {
        if (!this.code) {
            this.code = NewCartCode();
        }
        return JSON.stringify({
            code: this.code,
            productQty: this.productQty,
            currency: this.currency,
            promocodes: this.promocodes,
            bundles: this.bundles,
            exchanges: this.exchanges,
            data: this.data,
            total: this.total,
            subtotal: this.subtotal,
            final_lines: this.final_lines,
            shipping_cost: this.shipping_cost,
            shipping_cost_taxes: this.shipping_cost_taxes,
            discount_subtotal: this.discount_subtotal,
            taxes: this.taxes,
            plugins: this.plugins,
            discount: this.discount,
            discounts: this.discounts,
            extras: this.extras,
            repo: this.repo,
            validation: this.validation
        });
    }
    toBackend(extras) {
        this.extras = Object.assign(Object.assign({}, this.extras), extras);
        return JSON.stringify({
            code: this.code,
            booking: JSON.parse(localStorage.getItem("BOOKING_DATA")),
            productQty: this.productQty,
            final_lines: this.final_lines,
            currency: this.currency,
            exchanges: this.exchanges,
            promocodes: this.promocodes,
            data: this.data,
            bundles: this.bundles,
            total: this.total,
            subtotal: this.subtotal,
            shipping_cost: this.shipping_cost,
            shipping_cost_taxes: this.shipping_cost_taxes,
            discount_subtotal: this.discount_subtotal,
            taxes: this.taxes,
            plugins: this.plugins,
            discount: this.discount,
            discounts: this.discounts,
            repo: this.repo,
            extras: this.extras,
            validation: this.validation
        });
    }
    resetBookingData() {
        localStorage.removeItem('BOOKING_DATA');
    }
    resetCart() {
        if (window.API_URL.indexOf('localhost') >= 0) {
            return;
        }
        this.resetBookingData();
        localStorage.removeItem(this.identifier);
        this.reset_cart();
        localStorage.setItem(this.identifier, this.stringify());
        window.location.href = window.location.href;
    }
    loadFromJson(identifier, data) {
        let prev_identifier = this.identifier;
        this.identifier = identifier;
        localStorage.setItem(this.identifier, data);
        this.loadFromStorage();
        this.identifier = prev_identifier;
    }
    save() {
        localStorage.setItem(this.identifier, this.stringify());
    }
    loadFromStorage() {
        let data = JSON.parse(localStorage.getItem(this.identifier));
        if (!data) {
            return this;
        }
        this.code = data.code;
        this.repo = data.repo;
        this.data = data.data;
        this.final_lines = data.final_lines;
        this.currency = data.currency;
        this.productQty = data.productQty;
        this.promocodes = data.promocodes;
        this.bundles = data.bundles;
        this.exchanges = data.exchanges;
        this.subtotal = data.subtotal;
        this.shipping_cost = data.shipping_cost,
            this.shipping_cost_taxes = data.shipping_cost_taxes,
            this.discount_subtotal = data.discount_subtotal;
        this.taxes = data.taxes;
        this.plugins = data.plugins;
        this.discount = data.discount;
        this.discounts = data.discounts;
        this.total = data.total;
        this.extras = data.extras;
        this.validation = data.validation;
        this.formData = JSON.parse(localStorage.getItem("BOOKING_DATA"));
        if (!this.currency) {
            this.currency = GetCurrency();
        }
        return this;
    }
    static getOrCreateCart(identifier, settings) {
        if (!Cart.internalInstance) {
            console.debug('creating cart instance');
            Cart.internalInstance = new Cart(identifier, settings);
            Cart.internalInstance.loadFromStorage();
            Cart.internalInstance.save();
            Cart.internalInstance.refreshMiniCart();
            return Cart.internalInstance;
        }
        console.debug('getting new cart instance');
        Cart.internalInstance.loadFromStorage();
        Cart.internalInstance.refreshMiniCart();
        return Cart.internalInstance;
    }
    getApiCartPayload() {
        let formFilterData = null;
        if (this.initial && this.formData) {
            formFilterData = this.formData;
        }
        if (!formFilterData) {
            formFilterData = this.getFormData();
        }
        if (Object.keys(formFilterData || {}).length == 0) {
            formFilterData = null;
        }
        if (!formFilterData) {
            if (!this.data) {
                this.data = {};
            }
            formFilterData = this.data;
            formFilterData['location'] = GetLoc();
            formFilterData['warehouse'] = GetWar();
        }
        let eventType = 'cart';
        if (this.lastChange) {
            eventType = 'filters';
        }
        let user = null;
        if (window.Clkec) {
            user = window.Clkec.user.data;
            if (!user) {
                try {
                    formFilterData['email'] = window.Clkec.checkout.data[0]['step-customer-email'];
                }
                catch (e) { }
            }
            else {
                formFilterData['email'] = user['email'];
            }
        }
        if (!GetWar()) {
            SetWar(formFilterData['warehouse']);
        }
        if (!this.bundles) {
            this.bundles = [];
        }
        let payload = {
            items: this.get_products().map(item => {
                console.debug('ValidationPayload.item', item);
                return {
                    'quantity': item.quantity,
                    'code': item.code,
                    'friendly_code': item.friendly_code,
                    'id': item.id,
                    'price': item.price,
                    'symbol': item.symbol,
                    'name': item.name,
                    'slug': item.slug,
                    'image': item.image,
                    'selected_gift': item.gifts,
                    'stock': 0,
                };
            }),
            bundles: this.bundles.map(aux => {
                console.debug('ValidationPayload.bundle', aux);
                var bundle = aux;
                return {
                    'uuid': bundle.uuid,
                    'promo_id': bundle.promo_id,
                    'gifts': bundle.gifts,
                    'products': bundle.products.map(bundle_item => {
                        return {
                            'quantity': bundle_item.quantity,
                            'code': bundle_item.code,
                            'friendly_code': bundle_item.friendly_code,
                            'id': bundle_item.id,
                            'price': bundle_item.price,
                            'symbol': bundle_item.symbol,
                            'name': bundle_item.name,
                            'slug': bundle_item.slug,
                            'image': bundle_item.image,
                            'stock': 0,
                        };
                    })
                };
            }),
            extra_items: this.extras,
            currency: this.currency,
            promocodes: this.promocodes,
            pickup_date: null,
            options: {
                'data': formFilterData,
                'event': eventType,
                'last_change': this.lastChange
            },
            user: user
        };
        return payload;
    }
    async queryApiCart() {
        this.lastChange = null;
        this.initial = false;
        let payload = this.getApiCartPayload();
        let response = await this.settings.validatorAPI.validateCart(payload);
        if (!response) {
            const result = await window.Clkec.swal.fire({
                icon: 'error',
                title: 'Cart error!',
                timerProgressBar: false,
                timer: 3000,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: true
            });
            try {
                window.Clkec.cart.resetCart();
            }
            catch (e) { }
            try {
                window.Clkec.checkout.reset();
            }
            catch (e) { }
            return null;
        }
        return response;
    }
    raiseCartError(cartData) {
        try {
            cartData = "DATA: " + JSON.stringify(cartData);
        }
        catch (e) { }
        if (window.Sentry) {
            window.Sentry.captureMessage('Cart data processing failed', {
                level: 'error',
                extra: {
                    cartData: cartData,
                    timestamp: new Date().toISOString(),
                },
                tags: {
                    module: 'cart',
                    event: 'cart',
                },
            });
        }
        else {
            // throw new Error('Cart response null');
        }
    }
    async QueryMiniCart() {
        const response = await this.queryApiCart();
        if (response == null) {
            let cartData = null;
            try {
                cartData = this.getApiCartPayload();
            }
            catch (e) {
                cartData = e.toString();
            }
            //this.resetCart()
            //this.raiseCartError(cartData);
            return null;
        }
        console.debug('QueryMiniCart', response);
        if (response) {
            this.addCartResponse(response, true, false);
            // this.updateCart(response as ValidationResponse);
            // this.refreshMiniCart();
        }
    }
    addCartResponse(response, rMiniCart = true, rPageCart = true) {
        this.updateCart(response);
        if (rMiniCart) {
            this.refreshMiniCart();
        }
        if (rPageCart) {
            this.refreshPageCart();
        }
    }
    async QueryCart() {
        let response = await this.queryApiCart();
        if (response == null) {
            let cartData = null;
            try {
                cartData = this.getApiCartPayload();
            }
            catch (e) {
                cartData = e.toString();
            }
            //this.resetCart()
            //this.raiseCartError(cartData);
            return null;
        }
        console.debug('QueryCart', response);
        if (response) {
            this.addCartResponse(response, true, true);
            // this.updateCart(response as ValidationResponse);
            // this.refreshMiniCart();
            // this.refreshPageCart();
        }
        return response;
    }
    onFormFilterSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.formFilter = event.target;
        let form_data = getFormJSON(this.formFilter);
        function onsuccess(booking_data) {
            console.log('onFormFilterSubmit.onsuccess');
            var num_items = 0;
            var currency = isoCurrency(window.Clkec.cart.currency);
            try {
                if (window.fbq) {
                    // InitiateCheckout content_category, content_ids, contents, currency, num_items, value
                    num_items = 0;
                    var contents = window.Clkec.cart.get_products().map((item) => {
                        num_items += item.quantity;
                        return {
                            'quantity': item.quantity,
                            'id': item.id,
                        };
                    });
                    var InitiateCheckoutData = {
                        "content_ids": contents.map((item) => { return item['id']; }),
                        "contents": contents,
                        "num_items": num_items,
                        "value": window.Clkec.cart.total,
                        "currency": currency
                    };
                    window.fbq("track", "InitiateCheckout", InitiateCheckoutData);
                    console.log('CLKEC_EVENTS_EVENT', `window.fbq("track", "InitiateCheckout", ${JSON.stringify(InitiateCheckoutData)});`);
                }
            }
            catch (e) {
                console.error(e);
            }
            try {
                if (window.gtag) {
                    num_items = 0;
                    var items = window.Clkec.cart.get_products().map((item) => {
                        num_items += item.quantity;
                        return {
                            item_id: item.id,
                            item_name: item.name,
                            // discount: 2.22, esta item.discounts que es un []
                            // affiliation: 'Google Store',
                            item_brand: item.brand.name,
                            // item_category: 'pants',
                            // item_variant: 'black',
                            price: item.price,
                            currency: currency,
                            quantity: item.quantity
                        };
                    });
                    window.gtag('event', 'begin_checkout', {
                        currency: currency,
                        items: items,
                        value: window.Clkec.cart.total
                    });
                }
            }
            catch (e) {
                console.error(e);
            }
            setTimeout(() => {
                window.location.href = '/checkout/';
            }, 200);
        }
        validateReserve(form_data, onsuccess);
    }
    updateCart(data) {
        console.log('updateCart');
        if (!data.cart) {
            this.resetCart();
            return;
        }
        this.data = data.data;
        this.total = data.cart.total;
        this.subtotal = data.cart.subtotal;
        this.shipping_cost = data.cart.shipping_cost;
        this.shipping_cost_taxes = data.cart.shipping_cost_taxes;
        this.discount_subtotal = data.cart.discount_subtotal;
        this.taxes = data.cart.taxes;
        this.plugins = data.cart.plugins;
        this.discount = data.cart.discount;
        this.discounts = data.cart.discounts;
        this.validation = data.validation;
        this.final_lines = data.final_lines;
        let lines_to_remove = Object({});
        for (const [index, line] of this.repo.entries()) {
            lines_to_remove[line.id] = index;
        }
        let product_stocks = null;
        try {
            product_stocks = data.cart.stocks[parseInt(data.cart.data.deposit)].products;
        }
        catch (e) { }
        for (const [index, _line] of Object.entries(data.cart.lines).entries()) {
            let line = _line[1];
            let stock = null;
            if (product_stocks) {
                try {
                    stock = product_stocks[line.product.id].max_count;
                }
                catch (e) {
                    stock = 0;
                }
            }
            line.stock = stock;
            this.update_product_price(line);
            delete lines_to_remove[line.product.id];
        }
        this.repo = this.repo.filter(el => Object.keys(lines_to_remove).indexOf(el.id) < 0);
        this.productQty = 0;
        this.repo.forEach(el => { this.productQty += parseInt('' + el.quantity); });
        this.promocodes = data.cart.promocodes;
        this.bundles = data.cart.bundles;
        this.bundles.forEach(el => { this.productQty += parseInt('' + el.quantity); });
        this.exchanges = data.extras['exchanges'];
        this.save();
        if (this.formFilter) {
            this.formFilter.innerHTML = data.checkoutform;
        }
        if (data.data['location']) {
            SetLoc(data.data['location']);
            SetWar(null);
        }
        if (data.data['warehouse']) {
            SetWar(data.data['warehouse']);
        }
        console.log('==========================================');
        console.log(data, this.formFilter, this.formData);
        console.log('==========================================');
        if (this.formFilter) {
            let btn = this.formFilter.querySelector('button');
            if (btn) {
                btn.disabled = !this.validation.valid;
            }
        }
        console.log('raise', 'CartUpdated');
        document.dispatchEvent(new CustomEvent('CartUpdated', {
            'detail': {
                'data': data,
                'cart': this,
            }
        }));
        this.registerFormFilterEvents();
    }
    refreshMiniCart() {
        console.log('refreshMiniCart');
        let qtyDisplays = document.querySelectorAll(this.settings.qtyDisplayClass);
        let totalDisplays = document.querySelectorAll(this.settings.totalDisplayClass);
        qtyDisplays.forEach(el => { this.setText(el, this.productQty.toString()); });
        totalDisplays.forEach(el => { this.setText(el, this.currency + " " + this.formatAmount(this.total, 2)); });
        let counterDisplays = document.querySelectorAll('.cartcount');
        counterDisplays.forEach(el => { this.setText(el, this.productQty.toString()); });
    }
    refreshPageDetail() {
        this.refreshMiniCart();
        let subtotalDisplays = document.querySelectorAll(this.settings.subtotalDisplayClass);
        let discountDisplays = document.querySelectorAll(this.settings.discountDisplayClass);
        let discount_subtotalDisplays = document.querySelectorAll('.js-discount_subtotal-display');
        let taxesDisplays = document.querySelector(this.settings.taxesDisplayClass);
        let headerdetailsDisplay = document.querySelector(this.settings.headerdetailsDisplayClass);
        let footerdetailsDisplay = document.querySelector(this.settings.footerdetailsDisplayClass);
        subtotalDisplays.forEach(el => { this.setText(el, this.currency + " " + this.formatAmount(this.subtotal, 2)); });
        discount_subtotalDisplays.forEach(el => { this.setText(el, this.currency + " " + this.formatAmount(this.discount_subtotal, 2)); });
        discountDisplays.forEach(el => { this.setText(el, this.currency + " " + this.formatAmount(this.discount, 2)); });
        if (taxesDisplays) {
            taxesDisplays.innerHTML = '';
            if (this.taxes) {
                let entries = Object.entries(this.taxes);
                if (entries.length > 0) {
                    taxesDisplays.innerHTML = `<div class="item d-flex justify-content-between mb-2">
        </div>`;
                    entries.forEach(value => {
                        let text = value[0];
                        let tax = this.formatAmount(value[1].total, 2);
                        taxesDisplays.innerHTML += `
            <div class="item d-flex justify-content-between mb-2">
                <span>${text}:</span>
                <span class="text-primary js-discount-display">${this.currency} ${tax}</span>
            </div>`;
                    });
                }
            }
        }
        if (headerdetailsDisplay) {
            headerdetailsDisplay.innerHTML = '';
            if (!this.extras) {
                this.extras = {};
            }
            let shipping_cost = this.extras['shipping_cost'];
            if (shipping_cost) {
                shipping_cost = JSON.parse(shipping_cost);
                if (shipping_cost) {
                    let currency = this.currency;
                    let extra_shipping = document.createElement('div');
                    extra_shipping.className = 'text-center d-block';
                    extra_shipping.innerHTML = `
              <h3 class="text-primary text-left">Delivery: <button class="float-right d-none" type="button" onclick="Clkec.cart.removeShipping()">x</button></h3>
              <br>
              <div class="item d-flex justify-content-between mb-2">
                  <span>Costo de envío:</span>
                  <span class="text-primary">${currency} ${this.formatAmount(this.shipping_cost, 2)}</span>
              </div>`;
                    if (this.shipping_cost_taxes != null) {
                        extra_shipping.innerHTML += `
          <div class="item d-flex justify-content-between mb-2">
              <span>Impuestos:</span>
              <span class="text-primary">${currency} ${this.formatAmount(this.shipping_cost_taxes, 2)}</span>
          </div>
          `;
                    }
                    extra_shipping.innerHTML += `<hr>`;
                    headerdetailsDisplay.append(extra_shipping);
                }
            }
        }
        if (footerdetailsDisplay) {
            footerdetailsDisplay.innerHTML = '';
            if (this.exchanges) {
                var change_to_currency = '';
                Object.keys(this.exchanges).forEach(cur => {
                    if (this.currency == cur) {
                        return;
                    }
                    change_to_currency += `
          <li> <button class="btn btn-outline-secondary" onclick="changeCurrency(event, '${cur}')">Cambiar a ${cur} ${this.formatAmount(this.exchanges[cur], 2)}</button> </li>
          `;
                });
                change_to_currency = `<ul class="list-unstyled mt-4">${change_to_currency}</ul>`;
                footerdetailsDisplay.innerHTML += change_to_currency;
            }
        }
        let indicator = document.getElementById(this.settings.indicatorDisplayID);
        if (indicator) {
            if (this.productQty > 0) {
                indicator.classList.add(this.settings.indicatorDisplayNonEmptyClass);
            }
            else {
                indicator.classList.remove(this.settings.indicatorDisplayNonEmptyClass);
            }
        }
    }
    render_discounts() {
        let conEl = document.querySelector('#cart-discounts');
        if (!conEl) {
            console.debug(`Template 'cart-discounts' does not exist`);
            return;
        }
        let itemPTemplate = document.getElementById('checkout-discounts');
        if (!itemPTemplate) {
            console.debug(`Template 'checkout-discounts' does not exist`);
            return;
        }
        let itemProductTemplate = itemPTemplate.innerHTML;
        let template = Handlebars.compile(itemProductTemplate);
        conEl.innerHTML = template({ 'discounts': this.discounts, 'currency': this.currency });
    }
    removeShipping() {
        this.addExtra('shipping_cost', JSON.stringify(null));
        this.QueryCart();
    }
    registerFormFilterEvents() {
        if (this.formFilter) {
            let formFilterInputs = this.formFilter.querySelectorAll('input');
            console.debug('formFilter', 'input', formFilterInputs);
            formFilterInputs.forEach(inp => {
                inp.addEventListener('change', event => {
                    if (window.last_event) {
                        if (window.last_event == event) {
                            return;
                        }
                    }
                    window.last_event = event;
                    console.debug('formFilterInputs update input', event);
                    event.preventDefault();
                    event.stopPropagation();
                    const elem = event.target;
                    this.lastChange = { 'elem': elem.name, 'value': elem.value };
                    document.dispatchEvent(new CustomEvent('CartFilterUpdate', {
                        'detail': {
                            'lastChange': this.lastChange
                        }
                    }));
                    this.QueryCart();
                });
            });
            let formFilterSelects = this.formFilter.querySelectorAll('select');
            console.debug('formFilter', 'select', formFilterSelects);
            formFilterSelects.forEach(sel => {
                sel.addEventListener('change', event => {
                    if (window.last_event) {
                        if (window.last_event == event) {
                            return;
                        }
                    }
                    window.last_event = event;
                    console.debug('formFilterInputs update select', event);
                    event.preventDefault();
                    event.stopPropagation();
                    const elem = event.target;
                    this.lastChange = { 'elem': elem.name, 'value': elem.value };
                    if (elem.name == 'location') {
                        try {
                            const aux = document.getElementById('id_warehouse');
                            aux.value = '';
                        }
                        catch (e) { }
                        SetWar('');
                    }
                    document.dispatchEvent(new CustomEvent('CartFilterUpdate', {
                        'detail': {
                            'lastChange': this.lastChange
                        }
                    }));
                    this.QueryCart();
                });
            });
        }
    }
    refreshPageCart() {
        console.log('asdasd');
        this.render_discounts();
        let render;
        if (this.productQty === 0) {
            render = new HandlebarsRender(this.emptyTemplateSelector, this.containerSelector);
            document.querySelectorAll('.remove-if-cart-empty').forEach(el => {
                el.remove();
            });
            render.render({}, true);
        }
        else {
            render = new HandlebarsRender(this.templateSelector, this.containerSelector);
            var lines = this.get_lines();
            console.log(lines);
            console.log('refreshPageCart', lines);
            render.render(lines, true);
        }
        let deleteBtns = document.querySelectorAll('.js-delete-btn');
        deleteBtns.forEach(obj => {
            obj.addEventListener('click', event => {
                event.preventDefault();
                let target = event.currentTarget;
                let lineType = target.getAttribute('data-type');
                let lineId = target.getAttribute('data-id');
                let bundleIndex = target.getAttribute('data-bundle');
                let idqtyList = lineId.split(';');
                if (lineType == 'bundle') {
                    this.bundles.splice(parseInt(bundleIndex), 1);
                }
                else {
                    if (lineType == 'promo') {
                        idqtyList.forEach(idqtyItem => {
                            if (!idqtyItem) {
                                return;
                            }
                            var idqty = idqtyItem.split(',');
                            var prodId = idqty[0];
                            var prodQty = parseInt(idqty[1]);
                            this.decrement_product_qty(prodId.toString(), prodQty);
                        });
                    }
                    else {
                        idqtyList.forEach(idqtyItem => {
                            if (!idqtyItem) {
                                return;
                            }
                            var idqty = idqtyItem.split(',');
                            var prodId = idqty[0];
                            var prodQty = parseInt(idqty[1]);
                            this.decrement_product_qty(prodId.toString(), prodQty);
                        });
                    }
                }
                let row = target.closest('.cart-row');
                row.remove();
                this.QueryCart();
            }, { once: true });
        });
        this.refreshPageDetail();
        console.debug('refreshPageDetail');
        let qtyInputs = document.querySelectorAll('[name=qty]');
        qtyInputs.forEach(obj => obj.addEventListener('change', event => {
            event.preventDefault();
            event.stopPropagation();
            let target = event.currentTarget;
            let previous = target.getAttribute('data-qty');
            let current = target.value;
            let result = null;
            switch (parseInt(previous) < parseInt(current)) {
                case true:
                    result = this.increment_product_qty(target.getAttribute('data-id'), parseInt(current) - parseInt(previous));
                    break;
                case false:
                    result = this.decrement_product_qty(target.getAttribute('data-id'), parseInt(previous) - parseInt(current));
                    break;
            }
            if (result) {
                target.setAttribute('data-qty', current);
            }
            this.QueryCart();
        }));
        this.registerFormFilterEvents();
        document.dispatchEvent(new CustomEvent('onCartRenderFinish', {
            'detail': this
        }));
    }
    update_product_price(data) {
        const productID = data.product.id.toString();
        if (this.repo.find(obj => obj.info.product.id.toString() === productID)) {
            let product = this.repo.find(obj => obj.info.product.id.toString() === productID);
            if (!product) {
                return null;
            }
            product.price = data.price;
            product.symbol = data.currency;
            product.name = data.product.name;
            product.calculatedPrice = product.price * product.quantity;
            product.discounts = data.discounts;
            product.validations = data.validations;
            product.taxes = data.taxes;
            product.meta = JSON.parse(data.product.meta);
            product.stock = data.stock;
            product.real_warehouse = data.real_warehouse;
            product.is_hidden = data.is_hidden;
            this.save();
            return product;
        }
    }
    set_product_qty(product_id, quantity) {
        let data = this.increment_product_qty(product_id, quantity, true);
        this.QueryCart();
        return this.repo;
    }
    add_promo(promo_id, products, gifts, is_bundle, refresh = true) {
        if (is_bundle) {
            this.add_bundle(promo_id, products, gifts, refresh);
        }
        else {
            this.add_products(products, refresh, true);
        }
    }
    add_products(products, refresh = true, promo = false) {
        console.log('add_products', products);
        products.forEach((aux, index) => {
            var data = aux[0];
            if (!data || !data.id) {
                console.debug('add_products', index, aux);
                return;
            }
            console.log('add_products', data);
            var qty = aux[1];
            if (this.repo.find(obj => obj.id === data.id)) {
                this.increment_product_qty(data.id, qty);
            }
            else {
                data.quantity = (data.quantity) ? data.quantity + qty : qty;
                data.calculatedPrice = data.price * qty;
                this.productQty += qty;
                data.info = { 'product': Object.assign({}, data) };
                this.repo.push(data);
            }
        });
        this.save();
        if (refresh) {
            this.QueryMiniCart();
        }
        products.forEach((value) => {
            var data = value[0];
            this.settings.addProductSuccessCallback(this, data, 'add');
        });
        if (promo) {
            document.dispatchEvent(new CustomEvent('AddPromoEvent', {
                'detail': {
                    'products': products.map((el) => { return el[0]; })
                }
            }));
        }
        return this.repo;
    }
    add_bundle(promo_id, products, gifts, refresh = true) {
        var bundleId = uuidv4();
        console.log('add_bundle', bundleId, products);
        const promoMaxTimes = this.bundles.reduce((acc, el) => {
            var _a;
            acc[el.promo_id] = (_a = el.meta) === null || _a === void 0 ? void 0 : _a.max_times;
            return acc;
        }, {});
        const max_times = promoMaxTimes[promo_id];
        if (max_times > 0) {
            const promo_added = this.bundles.filter(el => { return el.promo_id == promo_id && el.meta.max_times > 0; });
            if (promo_added.length >= max_times) {
                window.Clkec.swal.fire({
                    icon: 'error',
                    title: `Limite maximo de ${max_times}`,
                    timerProgressBar: false,
                    timer: 3000,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: true
                });
                return;
            }
        }
        var bundle = {
            'uuid': bundleId,
            'promo_id': promo_id,
            'products': [],
            'gifts': gifts
        };
        products.forEach((aux, index) => {
            var data = aux[0];
            if (!data || !data.id) {
                console.debug('add_bundle', bundleId, index, aux);
                return;
            }
            var qty = aux[1];
            data.quantity = (data.quantity) ? data.quantity + qty : qty;
            console.log('add_bundle', bundleId, data);
            data.calculatedPrice = data.price * qty;
            data.info = { 'product': Object.assign({}, data) };
            bundle.products.push(data);
        });
        if (!this.bundles) {
            this.bundles = [];
        }
        this.bundles.push(bundle);
        this.save();
        if (refresh) {
            this.QueryMiniCart();
        }
        products.forEach((value) => {
            var data = value[0];
            this.settings.addProductSuccessCallback(this, data, 'add');
        });
        document.dispatchEvent(new CustomEvent('AddPromoEvent', {
            'detail': {
                'products': this.bundles
            }
        }));
        return this.repo;
    }
    add_product(data, quantity = 1, refresh = true) {
        if (this.repo.find(obj => obj.id === data.id)) {
            this.increment_product_qty(data.id, quantity);
        }
        else {
            data.quantity = (data.quantity) ? data.quantity + quantity : quantity;
            data.calculatedPrice = data.price * quantity;
            this.productQty += quantity;
            data.info = { 'product': Object.assign({}, data) };
            this.repo.push(data);
            this.save();
        }
        if (refresh) {
            this.QueryMiniCart();
        }
        this.settings.addProductSuccessCallback(this, data, 'add');
        return this.repo;
    }
    increment_product_qty(productID, quantity, forced = false) {
        let product = this.repo.find(obj => (obj['id'] + '') === (productID + ''));
        if (!product) {
            return null;
        }
        product.quantity = Number(product.quantity);
        var qtyToAdd = Number(quantity);
        if (forced) {
            qtyToAdd = Number(quantity) - Number(product.quantity);
            product.quantity = Number(quantity);
        }
        else {
            product.quantity += Number(quantity);
        }
        product.calculatedPrice = product.price * Number(product.quantity);
        this.productQty += qtyToAdd;
        this.save();
        return product;
    }
    decrement_product_qty(productID, quantity) {
        let product = this.repo.find(obj => (obj['id'] + '') === (productID + ''));
        if (!product) {
            return null;
        }
        product.quantity = Number(product.quantity);
        product.quantity -= Number(quantity);
        product.calculatedPrice = product.price * Number(product.quantity);
        this.productQty -= Number(quantity);
        return product;
    }
    remove_product(productID) {
        let product = this.repo.find(obj => (obj['id'] + '') === (productID + ''));
        if (product) {
            this.repo.splice(this.repo.indexOf(product), 1);
            this.total -= product.calculatedPrice;
            this.productQty -= product.quantity;
            this.save();
        }
        // this.QueryMiniCart();
        this.settings.addProductSuccessCallback(this, product, 'remove');
        return true;
    }
    addExtra(key, value) {
        this.extras[key] = value;
        this.save();
    }
    setExtra(key, value) {
        this.addExtra(key, value);
    }
    getExtra(key) {
        if (!this.extras) {
            return;
        }
        return this.extras[key];
    }
    reset_cart() {
        this.code = null;
        this.productQty = 0;
        this.subtotal = 0;
        this.discount_subtotal = 0;
        this.discount = 0;
        this.final_lines = [];
        this.currency = '';
        this.data = Object({});
        this.total = 0;
        this.shipping_cost = null;
        this.shipping_cost_taxes = null;
        this.taxes = {};
        this.plugins = {};
        this.promocodes = [];
        this.bundles = [];
        this.exchanges = {};
        this.repo = [];
        this.extras = Object({});
        this.save();
        this.refreshMiniCart();
    }
    get_products() {
        this.repo = this.repo.filter(el => el.quantity > 0);
        return this.repo;
    }
    get_lines() {
        return this.final_lines.map((row) => {
            const row_type = row.type;
            try {
                row.line.product.meta = JSON.parse(row.line.product.meta);
            }
            catch (e) { }
            try {
                row.product.meta = JSON.parse(row.product.meta);
            }
            catch (e) { }
            if (row.line) {
                row = Object.assign(Object.assign({}, row.line), { type: row_type });
            }
            return row;
        });
    }
}
